import React from 'react';

export type PaymentContext = {
  showCheckoutForm: boolean;
  setShowCheckoutForm: () => void;
};

const paymentContext = React.createContext<PaymentContext | undefined>(undefined);

export const PaymentContextProvider = paymentContext.Provider;

export const usePaymentContext = () => {
  const context = React.useContext(paymentContext);
  if (!context) {
    throw new Error('usePaymentContext must be used within a PaymentContextProvider');
  }
  return context;
};
